import { computed, type ComputedRef } from 'vue'
import { useNow } from '@/composables/game/time'
import { formatDuration } from '@/helpers/date'

export const useClaimTask = (task: ComputedRef<{
  id?: string,
  actionCompletedAt?: number,
  claimDelay?: number,
  error?: string
}>) => {
  const { now } = useNow()

  const hasOpenedUrl = computed(() => !!task.value.actionCompletedAt && !task.value.error)
  const claimDelay = computed(() => task.value.claimDelay)
  const remainedSecondsUntilClaim = computed(() => {
    if (!hasOpenedUrl.value || !claimDelay.value) return 0
    const claimTime = (task.value.actionCompletedAt as number) + claimDelay.value
    const remainingSeconds = claimTime - now.value
    return remainingSeconds > 0 ? remainingSeconds : 0
  })

  const claimDelayFormattedTime = computed(() => {
    if (!remainedSecondsUntilClaim.value) return undefined
    return formatDuration(remainedSecondsUntilClaim.value, 'mm:ss')
  })

  return {
    hasOpenedUrl,
    remainedSecondsUntilClaim,
    claimDelayFormattedTime,
  }
}